<template>
  <div class="zyc-button-group">
    <div :id="id">
      <el-button type="text" v-for="i in list" :key="i.id" @click="butClick(i)" :class="i.active ? 'active':''">{{ i.title }}</el-button>
      <div style="clear:both;"></div>
    </div>
    <div style="clear:both;"></div>
  </div>
</template>
<script>
  
  /**
  * 按钮组
  */
  export default {
    name: 'zycButtonGroup',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      butGroupChange: {
        type: Function,
        default: () => { }
      }
    },
    model: {
    },
    watch: {
      data: {
        handler: function (newName, oldName) {
          this.list = newName
          if (this.row) {
            this.refresh(this.row)
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        id: Math.random().toString(36).slice(2),
        list: [],
        level: 1,
        row: null
      }
    },
    mounted() {

    },
    created() {
    },
    methods: {
      butClick: function (obj) {
        this.row = obj
        this.list.forEach((el, i) => {
          if (el.id == obj.id) {
            if (obj.active) {
              obj.active = false
            } else {
              obj.active = true
            }
          } else {
            this.list[i].active = false
          }
        })
        this.butGroupChange(obj, this.level)
        this.$forceUpdate()
      },
      reload: function (lv) {
        if (lv == 2) {
          this.list.forEach((el, i) => {
            this.list[i].active = false
          })
        } else {
          this.data.forEach(el => {
            el.active = false
          })
          this.level = 1
          this.list = this.data
        }
        this.$forceUpdate()
      },
      refresh: function (obj) {
        if (typeof (obj.childs) != 'undefined' && obj.childs.length > 0) {
          this.list = obj.childs
          this.list.forEach(el => {
            el.active = false
          })
          this.level++
        } else {
          this.list.forEach((el, i) => {
            this.list[i].active = false
            if (el.id == obj.id) {
              this.list[i].active = true
            }
          })
        }
        this.$forceUpdate()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/button/buttonGroup.vue